import React from 'react';
import { Layout } from 'antd';
import LogoEmpresa from '../../assets/img/a1-8.png';

export default function Footer() {
  return (
    <Layout.Footer
      style={{
        width: '100%',
        marginTop: 'auto',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        padding: '20px',
      }}
    >
      {/* Texto principal */}
      <div>
        © 2024 Portal de Turnos - Un desarrollo de AmpinaSoft. ¡Simplificando tu
        gestión de turnos!
      </div>

      {/* Firma con logo y enlace */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img src={LogoEmpresa} alt="AmpinaSoft" style={{ height: '30px' }} />
        <a
          href="https://ampinasoft.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#1890ff',
            fontWeight: 'bold',
            textDecoration: 'none',
          }}
        >
          Descubre nuestros servicios
        </a>
      </div>
    </Layout.Footer>
  );
}
